import { GraphQLResult } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { Dispatch, DispatchWithoutAction, SetStateAction } from "react";
import { toast } from 'react-toastify';

import { deleteNutrient } from "../../../graphql/mutations";
import { updateLoading } from "../../../redux/slice/appSlice";
import { AppDispatch } from "../../../redux/store";
import { DeleteNutrientMutation, Nutrient } from "../../../types/api";

interface deleteNutrientByIdProps {
  id: string | undefined;
  index: number;
  dispatch: AppDispatch;
  updateNutrients: Dispatch<SetStateAction<(Nutrient | null)[]>>;
  forceUpdate: DispatchWithoutAction;
}
export const deleteNutrientById: ({
  id,
  index,
  dispatch,
  updateNutrients,
  forceUpdate
}: deleteNutrientByIdProps) => Promise<void> = async ({
  id,
  index,
  dispatch,
  updateNutrients,
  forceUpdate
}: deleteNutrientByIdProps) => {
  try {
    dispatch(updateLoading(true));
    const deleteResponse: GraphQLResult<DeleteNutrientMutation> =
      await API.graphql({
        query: deleteNutrient,
        variables: { input: { id } }
      }) as GraphQLResult<DeleteNutrientMutation>;
    if (deleteResponse.data?.deleteNutrient) {
      updateNutrients((prevState) => {
        if (prevState) {
          prevState.splice(index, 1);
        }
        return prevState;
      });
      forceUpdate();
    }
  } catch (err) {
    // console.log(err)
    toast.dark("Error: Delete Nutrient");
  } finally {
    dispatch(updateLoading(false));
  }
};
